import React, { useContext, useCallback } from 'react';
import moment from 'moment';
import { PageContext } from '../../../../context';
import { ContentContext } from '../../context';
import { ContentWrapper } from '../../../../styles';
import { Label, TimeSlotsWrapper, TimeSLotItem } from './styles';

const ServiceTimeSlots = () => {
  const context = useContext(PageContext);
  const {
    formData: { serviceDay, serviceInterval },
    selectEventTime,
  } = context;

  const {
    contextData: { getAvailableTimeSlots },
  } = useContext(ContentContext);

  const handleTimeClick = useCallback(
    (id) => {
      selectEventTime(id);
    },
    [selectEventTime],
  );

  if (!serviceDay) {
    return <Label> Please select a date </Label>;
  }

  const intervals = getAvailableTimeSlots();

  return (
    <>
      <Label active>{`${moment(serviceDay).format('ddd MMM Do')} Selected`}</Label>

      <ContentWrapper nopadding>
        <TimeSlotsWrapper>
          {intervals.map((ts) => (
            <TimeSLotItem
              key={`${moment(serviceDay).format('D M Y')}_${ts}`}
              active={serviceInterval && serviceInterval === ts}
              onClick={() => handleTimeClick(ts)}
            >
              {moment(ts, 'hh:mm:ss').format('LT')}
            </TimeSLotItem>
          ))}
        </TimeSlotsWrapper>
      </ContentWrapper>
    </>
  );
};

ServiceTimeSlots.propTypes = {};

export default ServiceTimeSlots;
